import '@fontsource/roboto';
import '@fontsource/roboto/400-italic.css';
import '@fontsource/roboto/400.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { Router, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import 'semantic-ui-css/semantic.min.css';
import { LoadingProvider } from './components/LoadingContext/LoadingContext';
import Toolbar from './components/Navbar';
// import TermAccessibility from './components/TermAccessibility';
import Routes from './routes/routes';
import history from './services/history';
import store, { persistor } from './store';
import GlobalStyle from './styles/GlobalStyles';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 15 * 60 * 1000,
    },
  },
});

function AppContent() {
  // const { isLoggedIn } = getAuth();
  const location = useLocation();

  const hideToolbar =
    location.pathname === '/loading' ||
    location.pathname === '/login' ||
    location.pathname === '/';

  return (
    <>
      {!hideToolbar && <Toolbar />}
      <LoadingProvider>
        {/* {isLoggedIn && <TermAccessibility />} */}
        <div className="main-content-container">
          <Routes />
        </div>
      </LoadingProvider>
      <GlobalStyle />
      <ToastContainer autoClose={3000} className="toast-container" />
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <Router history={history}>
            <AppContent />
          </Router>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
